import millify from 'millify'
export interface ICurrencyFormatOption {
    fraction: boolean
    isAccounting?: boolean
    signDisplay?: boolean
}
//also use in CFD
function currencyFormat(
    value: number | string,
    currencyLanguage: string,
    currencyCode: string,
    options: ICurrencyFormatOption = {
        fraction: true,
        isAccounting: false,
    },
) {
    if (typeof value === 'string') value = parseFloat(value)

    const signDisplay = options.signDisplay
        ? 'exceptZero'
        : value === 0
          ? 'never'
          : 'auto'

    if (currencyCode === 'THB') {
        // THB uses style:'decimal' and appends ฿ manually.
        // Using style:'currency' with a RTL locale (e.g. he-HE) was a previous
        // workaround to place ฿ after the number, but it caused Intl.NumberFormat
        // to inject invisible Unicode directional markers (U+200F, U+202F, etc.)
        // that receipt printers cannot render, printing them as '?' characters.
        // style:'currency' also doesn't support ฿-after-number with any non-RTL locale.
        // currencySign:'accounting' requires style:'currency', so negative accounting
        // format (parentheses) is handled manually below instead.
        const formatted = new Intl.NumberFormat(currencyLanguage, {
            style: 'decimal',
            minimumFractionDigits: options.fraction ? 2 : undefined,
            maximumFractionDigits: options.fraction ? 2 : undefined,
            signDisplay,
        }).format(value ?? 0)

        if (options.isAccounting && value < 0) {
            return `(${formatted.replace('-', '')}฿)`
        }
        return `${formatted}฿`
    }

    return new Intl.NumberFormat(currencyLanguage, {
        minimumFractionDigits: options.fraction ? 2 : undefined,
        maximumFractionDigits: options.fraction ? 2 : undefined,
        currencySign: options?.isAccounting ? 'accounting' : 'standard',
        currency: currencyCode,
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        signDisplay,
    }).format(value ?? 0)
}
export default currencyFormat

export function currencyMillifyFormat(
    value: number | string,
    currencyLanguage: string,
    currencyCode: string,
    { fraction = true, isAccounting = false }: ICurrencyFormatOption,
) {
    if (typeof value === 'string') value = parseFloat(value)
    var formatResult = currencyFormat(value, currencyLanguage, currencyCode, {
        fraction,
        isAccounting,
    })
    var numberPattern = /[\d,.]+/g

    return `${formatResult.replace(
        numberPattern,
        millify(value, {
            precision: 2,
        }),
    )}`
}
